import css from './definitionPane.module.scss';

import { memo } from 'react';

import { formatNote } from 'core/helpers/text';

type Props = {
  note: string;
  finished: boolean;
};
const Note: React.FC<Props> = ({ note, finished }) => (
  <div className={css.note}>{formatNote(note, finished)}</div>
);

export default memo(Note);
